const translations = {};

export const setTranslation = (key, value) => {
  translations[key] = value;
};

export const defineTranslations = (definition) =>
  Object.keys(definition).forEach((key) => setTranslation(key, definition[key]));

export function getTranslation(key: string, defaultValue?: string): string {
  return translations[key] || defaultValue || '';
}

type InterpolatableVariable = 'ITEM' | 'POSITION' | 'TOTAL';

export function replaceVariables(
  template: string,
  variables: { [K in InterpolatableVariable]?: string | number }
) {
  return Object.entries(variables).reduce((result, [key, value]) => {
    const regex = new RegExp(`#\\{${key}\\}`, 'g');
    return result.replace(regex, String(value));
  }, template);
}

export function LEGACY_replaceVariables(
  template: string,
  variables: Array<string>,
  replaceValue: string = '%s'
) {
  if (!template) {
    return '';
  }

  let stringWithReplacements = template;

  variables.forEach((val) => {
    stringWithReplacements = stringWithReplacements.replace(replaceValue, val);
  });

  return stringWithReplacements;
}
